import { useEffect, useRef } from "react";
import { useAudioPlayback } from "@/common/hooks/useAudioPlayback";
import { URLSearchParamKeys } from "@/enum/URLSearchParamKeys";
import useExplorerItems from "@/common/hooks/useExplorerItems";
import useCurrentExplorerItemId from "@/common/hooks/useCurrentExplorerItemId";
import { useSearchParamState } from "@/common/hooks/nuqs/useSearchParamState";

export const useSetCurrentExplorerItemBySearchParam = () => {
  const [explorerItems] = useExplorerItems();
  const [currentExplorerItemId, setCurrentExplorerItemId] = useCurrentExplorerItemId();
  const [currentExplorerItemIdSearchParam] = useSearchParamState(URLSearchParamKeys.TRACK);
  const { setSource } = useAudioPlayback();
  const handleSyncRef = useRef(() => {
  });

  handleSyncRef.current = async () => {
    if (!explorerItems || !currentExplorerItemIdSearchParam) {
      return;
    }

    const item = explorerItems[currentExplorerItemIdSearchParam];

    if (item?.id && currentExplorerItemId !== currentExplorerItemIdSearchParam) {
      console.log('Synchronizing explorer item', {
        from: currentExplorerItemId,
        to: currentExplorerItemIdSearchParam
      });

      setCurrentExplorerItemId(item.id);
      setSource(item);
    }
  };

  // PopState event handler
  useEffect(() => {
    const handlePopState = () => handleSyncRef.current();

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  // URL parameter change monitor
  useEffect(() => {
    handleSyncRef.current();
  }, [
    currentExplorerItemIdSearchParam,
    currentExplorerItemId,
    explorerItems
  ]);
}
